import { render, staticRenderFns } from "./InsertionLengthInput.vue?vue&type=template&id=6f1bed6c&"
import script from "./InsertionLengthInput.vue?vue&type=script&lang=js&"
export * from "./InsertionLengthInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports